/**
 * logDisplay — how an execution log line reads in the Logs viewer.
 *
 * The engine writes emoji markers into log messages ("📤 SENDING: AT+CSQ",
 * "   │    ✅ Status: OK"). The stored logs keep them; the viewer shows the
 * message without them, terminal-style. Indentation, the primitive-log
 * frame (│ ┌ ─), arrows (→) and the text itself stay as they are.
 */

// One emoji (with variation selector / ZWJ sequence) and the space after it.
const EMOJI = /\p{Extended_Pictographic}(?:\uFE0F|\u200D\p{Extended_Pictographic})*\uFE0F? ?/gu;

/** The message with emoji removed; whitespace before them is kept. */
export function displayLogMessage(message: string): string {
  return message.replace(EMOJI, '').replace(/\s+$/, '');
}
